import { useRoutes } from 'react-router-dom';

import FullLayout from './layouts/FullLayout';
import PublicLayout from './layouts/PublicLayout';

import Home from './pages/Home';
import Auth from './pages/Auth';
import Login from './pages/Login';
import Plans from './pages/Plans';
import Profile from './pages/Profile';
import Boletas from './pages/Boletas';
import Payment from './pages/Payment';
import PayBill from './pages/PayBill';
import NotFound from './pages/NotFound';
import QRPayment from './pages/QRPayment';
import MyPayments from './pages/MyPayments';
import PlanProposal from './pages/PlanProposal';
import MisImponibles from './pages/MisImponibles';
import OfflinePayment from './pages/OfflinePayment';
import PreguntasFrecuentes from './pages/PreguntasFrecuentes';
import OfflinePaymentFinal from './pages/OfflinePaymentFinal';
import Debito from './pages/Debito';
import MediosPagos from './pages/MediosPagos';


export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <FullLayout />,
      children: [
        { path: '/', element: <Home /> },
        { path: '/imponibles/:id', element: <MisImponibles /> },
        { path: '/mis-pagos', element: <MyPayments /> },
        { path: '/consultas/pagos', element: <MyPayments /> },
        { path: '/perfil', element: <Profile /> },
        { path: '/planes/', element: <Plans /> },
        { path: '/planes/propuesta-plan', element: <PlanProposal /> },
        { path: '/pagar', element: <Payment /> },
      ],
    },
    {
      path: '/',
      element: <PublicLayout />,
      children: [
        { path: '/preguntas-frecuentes', element: <PreguntasFrecuentes /> },
        { path: '/paga-tu-tasa/consulta/pago', element: <OfflinePaymentFinal /> },
        { path: '/paga-tu-tasa/qr/:nroComprobante', element: <QRPayment /> },
        { path: '/paga-tu-tasa/consulta', element: <OfflinePayment /> },
        { path: '/paga-tu-tasa', element: <PayBill /> },
        { path: '/boleta', element: <Boletas /> },
        { path: '/debito-automatico', element: <Debito /> },
        { path: '/debito-automatico/medios-pagos', element: <MediosPagos /> },
      ],
    },
    { path: 'auth', element: <Auth /> },
    { path: 'login', element: <Login /> },
    { path: '*', element: <NotFound /> },
  ]);
}